import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { CancellationDetails, CancelledMessage, Document } from '../models';
import { JsonHttpService } from '../../shared/http/json-http.service';
import { CancelledMessageCorrelation } from '../models/cancelled-message-correlation';

@Injectable({
    providedIn: 'root'
})
export class MessageCancellationService {

    constructor(private httpService: JsonHttpService) { }

    public testRepository(): Promise<void> {
        return this.httpService.post('/api/tracking/messagecancellation/test-repository', null, null).toPromise();
    }

    cancelMessages(interchangeInIds: number[], documentIds: number[], interchangeOutIds: number[]): Promise<void> {
        const requestBody = {
            interchangeInIds,
            documentIds,
            interchangeOutIds,
          };

          return this.httpService.post('/api/tracking/messagecancellation/cancel-message', requestBody).toPromise();
    }

    getCancelledMessages(): Promise<CancelledMessage[]> {
        return this.httpService.get('/api/tracking/messagecancellation/get-all').toPromise();
    }

    getCancelledDocuments(correlationId: string): Promise<Document[]> {
        const options = { params: new HttpParams().set('correlationId', correlationId) };
        return this.httpService.get('/api/tracking/messagecancellation/get-cancelled-documents', options).toPromise();
    }

    getCorrelations(): Promise<CancelledMessageCorrelation[]> {
        return this.httpService.get('/api/tracking/messagecancellation/get-correlations').toPromise();
    }

    getCancellationDetails(correlationId: string): Promise<CancellationDetails> {
        const options = { params: new HttpParams().set('correlationId', correlationId) };
        return this.httpService.get('/api/tracking/messagecancellation/get-cancellation-details', options).toPromise();
    }
}
